import { render, staticRenderFns } from "./CommDialog.vue?vue&type=template&id=c961736c"
import script from "./CommDialog.vue?vue&type=script&lang=js"
export * from "./CommDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports